import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const play = css`
  position: absolute;
  top: 1rem;
  right: 0.75rem;
  z-index: 30;
`;

export const playing = css`
  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0px rgba(255, 255, 255, 0.2);
    }
    100% {
      box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
    }
  }
  animation: pulse-animation 0.75s infinite;
`;

export const player = css`
  aspect-ratio: 16/9;
  width: 100%;
  z-index: 10;
  @media screen and (width > ${theme.sizes.screens.md}) {
    max-width: 80%;
  }
`;

export const video = css`
  position: absolute;
  object-fit: contain;
  object-position: center;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
`;

export const spinner = css`
  width: 30px;
  height: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
